<template>
  <div class="footer">
    <div class="footer-container"></div>
    <footer>
      <div class="container-fluid">
        <div class="row between-xs middle-xs">
          <div class="email">
            <p>say hi - <a href="mailto:hello@djmelodie.com" class="text-bold prime-color">hello@djmelodie.com</a></p>
          </div>
          <div class="pagination">
            <p>Melodie 2018</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'

    export default {
    name: 'Footer',
    components: {
      UiBaseIcon
    },
    data () {
      return {
        currentYear: new Date().getFullYear(),
        pages:[
          'index',
          'intro',
          'portfolio',
          'contact'
        ],
        current: null,
      }
    },
    mounted () {
      const container = document.querySelector('.footer');
      const footer = document.querySelector('footer').offsetHeight;
      console.log(container);
      console.log(footer);
      container.setAttribute('style', 'height: ' + footer + 'px');
    },
    methods: {
      goToPage(pagename) {
        this.current = pagename;
        this.$router.push({ name: this.current });
      },
      goToNextPage() {
        this.$parent.gotoNextScreen();
      },
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
  footer {
    //position: relative;
    //text-align: center;
    //padding: $footer-padding;
    //width: 100%;
    //margin: $footer-margin;
    //border: 1px solid $grey-color;
    background-color: $dark-color;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    padding: 3rem 2rem 4rem;
    position: fixed;
    width: 100%;
    z-index: 0;
    color: $paper;
  }

  .footer-container,
  .footer {
    width: 1px;
  }

  .pagination-dots.component{
    display: flex;
    align-items: center;
    li {
      button {
        cursor: pointer;
        display: block;
        background: $prime-color;
        width: 10px;
        height: 10px;
        margin: 5px;
        border-radius: 50%;
        border: none;
        &:disabled {
          cursor: not-allowed;
        }
      }
    }
  }

  .arrows {
    cursor: pointer;
    position: relative;
    width: 20px;
    height: 40px;

    > .circle {
      width: 20px;
      height: 20px;
      display: block;
      background: rgba($prime-color, .25);
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    > .arrowDown {
      fill: $grey-color;
      padding-top: 10px;
    }

    > .bounce {
      -moz-animation: bounce 2s infinite;
      -webkit-animation: bounce 2s infinite;
      animation: bounce 2s infinite;
    }
  }

  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-15px);
    }
  }

</style>



// WEBPACK FOOTER //
// src/layout/Footer.vue